import { useLayoutEffect } from 'react'

import { useIsMd } from './style'

export function useLockBodyScroll(options: { skipOnMobile?: boolean } = {}) {
  const isMd = useIsMd()
  useLayoutEffect(() => {
    if (!isMd && options.skipOnMobile) return
    const originalStyle = window.getComputedStyle(document.body).overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = originalStyle
    }
  }, [])
}
